import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_BUNDLE_LIST_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveBundleList } from 'Actions';

const fetchBundleListEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_BUNDLE_LIST_REQUEST),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.post(
          `${import.meta.env.VITE_API_DOMAIN}/api/bundles/list?page=all`,
          action.options
        )
      ).pipe(
        map((response) => receiveBundleList(response.data.bundles)),
        catchError((error) => {
          console.error('fetchBundleListEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default fetchBundleListEpic;
